<template>
    <div class="el-grid-card">
        <div class="el-grid-card__header">{{ $t('title.overview') }}</div>
        <div class="el-grid-card__body">
            <el-row>
                <el-table
                    :data="processedUnloadingAreas"
                    size="mini"
                    class="w-full mb-6"
                    v-loading="loading"
                    border
                >
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'Description')"
                        prop="Description"
                        :label="$t('table.column.description')"
                    ></el-table-column>
                    <el-table-column
                        sortable
                        :sort-method="
                            (a, b) => sortBy(a, b, 'ShortDescription')
                        "
                        prop="ShortDescription"
                        :label="$t('table.column.shortDescription')"
                    ></el-table-column>
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'checkpointNames')"
                        prop="checkpointNames"
                        :label="$t('table.column.associatedCheckpoints')"
                        width="220"
                    ></el-table-column>
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'MaxPassages')"
                        prop="MaxPassages"
                        :label="$t('table.column.maxPassages')"
                        width="220"
                    >
                        <template slot-scope="{ row }">
                            <span v-if="!row.MaxPassages">{{$t('table.column.notSet')}}</span>
                            <span v-if="row.MaxPassages">{{row.MaxPassages}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'GeoLocation')"
                        prop="GeoLocation"
                        :label="$t('table.column.geoLocation')"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        sortable
                        prop="Color"
                        :label="$t('table.column.colorCode')"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <div :style="{ backgroundColor: row.Color }">
                                &nbsp;
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        :resizable="false"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <div class="btn-action-wrapper">
                                <a
                                    href="#"
                                    v-if="
                                        permissions.includes(
                                            'UNLOADINGAREA_WRITE'
                                        )
                                    "
                                    @click.prevent="edit(row)"
                                    class="btn-action"
                                >
                                    <v-btn flat icon color="cyan darken-3">
                                        <v-icon>mode_edit</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    v-if="
                                        permissions.includes(
                                            'UNLOADINGAREA_DELETE'
                                        )
                                    "
                                    class="btn-action"
                                    @click.prevent="remove(row)"
                                    title="Delete"
                                >
                                    <v-btn flat icon color="red darken-3">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InteractWithSort from '../../mixins/interact-with-sort'

export default {
    name: 'unloading-area-list',

    props: {
        associatedCheckpoints: Array
    },

    data() {
        return {
            loading: false,
            unloadingAreas: []
        }
    },

    mixins: [InteractWithSort],

    computed: {
        ...mapGetters(['selectedContainer', 'permissions']),

        processedUnloadingAreas() {
            return this.unloadingAreas.map(unloadingArea => {
                const checkpoints = this.associatedCheckpoints.filter(
                    associatedCheckpoint => {
                        return unloadingArea.Checkpoints.some(checkpoint => {
                            return (
                                associatedCheckpoint.CheckpointID === checkpoint
                            )
                        })
                    }
                )
                return {
                    ...unloadingArea,
                    checkpoints: checkpoints,
                    checkpointNames: checkpoints
                        .map(checkpoint => {
                            return checkpoint.CommonName
                        })
                        .join(', '),
                }
            })
        },
    },

    created() {
        this.fetch()

        Events.$on('unloading-area-updated', () => {
            this.fetch()
        })
    },

    watch: {
        // selectedContainer(container) {
        //     this.fetch(container)
        //     this.fetchCheckpoints(container)
        // },
    },

    methods: {
        async fetch(container = null) {
            this.loading = true

            container = container || this.selectedContainer

            if (container) {
                let { data } = await this.$http.get(
                    `Container/${container.ContainerID}/UnloadingArea`
                )
                this.unloadingAreas = data
            }
            this.loading = false
        },

        edit(unloadingArea) {
            Events.$emit('unloading-area-editing', unloadingArea)
        },

        async remove(unloadingArea) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t(
                            'form.label.unloadingArea'
                        ),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                await this.$http.delete(
                    `UnloadingArea/${unloadingArea.UnloadingAreaID}`
                )
                await this.fetch()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: this.$i18n.i18next.t(
                            'form.label.unloadingArea'
                        ),
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },
    },
}
</script>
